import React, { useState, useEffect, useCallback } from 'react';
import { Flex } from '@chakra-ui/react';
import AsyncSelect from 'react-select/async';
import { useRecoilState } from 'recoil';
import { tableAtom } from './atoms';
import { gql, useLazyQuery } from '@apollo/client';
import { debounce } from 'lodash';
import { useSearchParams, useNavigate } from 'react-router-dom';

const GET_PLACES = gql`
  query Places_List(
    $filter: FilterFindManyplacesInput
    $regexp: places_regexp_OTC
  ) {
    places_List(filter: $filter, regexp: $regexp) {
      items {
        _id
        name
      }
    }
  }
`;

const CustomPlaceSearch = ({ filters, searchForPlace }) => {
  const [selected, setSelected] = useState(null);
  const [tableState, setTableState] = useRecoilState(tableAtom);
  const [fetchTypes] = useLazyQuery(GET_PLACES);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const placeId = searchParams.get('placeId');
    if (placeId) {
      fetchTypes({
        variables: { filter: { _id: placeId } },
        onCompleted: (res) => {
          const item = res?.places_List?.items?.[0];
          if (item) {
            const option = {
              label: item.name,
              value: item._id,
              name: item.name,
              _id: item._id,
            };
            setSelected(option);
          }
        },
      });
    }
  }, []);

  const handleLoadPlaces = async (inputValue, callback) => {
    const { data: placesData } = await fetchTypes({
      variables: {
        regexp: {
          name: inputValue,
        },
      },
    });
    callback(
      placesData?.places_List?.items?.map((p) => ({
        label: p.name,
        value: p._id,
        name: p.name,
        _id: p._id,
      })) || []
    );
  };

  const debouncedSearch = useCallback(
    debounce((inputValue, callback) => {
      if (!inputValue || inputValue.length < 3) {
        return callback([]);
      }

      fetchTypes({
        variables: {
          regexp: {
            name: inputValue,
          },
        },
        onCompleted: (res) => {
          const options =
            res?.places_List?.items?.map((p) => ({
              label: p.name,
              value: p._id,
              name: p.name,
              _id: p._id,
            })) || [];
          callback(options);
        },
      });
    }, 500),
    []
  );

  const handlePlaceChange = (option) => {
    setSelected(option);
    console.log('Selected place:', option);
    searchForPlace(option?._id || null);
  };

  return (
    <Flex w='full' flexDirection='row' gap='10px' px='10px'>
      <AsyncSelect
        styles={{
          container: (provided) => ({
            ...provided,
            width: '100%',
            flex: 'wrap',
          }),
        }}
        placeholder='Search via places'
        isClearable
        isSearchable
        value={selected}
        getOptionLabel={(o) => o?.name}
        getOptionValue={(o) => o?._id}
        onChange={handlePlaceChange}
        loadOptions={handleLoadPlaces}
      />
    </Flex>
  );
};

export default CustomPlaceSearch;
